import { NAME } from "./constants"

export const CHANGE_SECTION = `${NAME}/CHANGE_SECTION`
export const RETURN_TO_SECTION = `${NAME}/RETURN_TO_SECTION`
